export const Colors = {
  Green: '#04A130',
  Orange: '#D99C00',
  Red: '#BA0303',
  DarkBlue: '#001F54',
};
